import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Pencil } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  id: string
  name: string
  canEditRole: boolean
}

export const JobRoleHeader = ({ id, name, canEditRole }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <ResourceHeader
      title={name}
      secondaryActions={[
        {
          label: i18n.t('common.edit'),
          icon: Pencil,
          isVisible: canEditRole,
          onClick: () => {
            navigate(
              navigation.employees.jobCatalog.role.settings.fullPath({
                id: id,
              })
            )
          },
        },
      ]}
    />
  )
}
